export default "<app-projet [newsList]=deplacements></app-projet>\n"